export default __webpack_public_path__ + "images/assets/8d44bd9a4b2ece48d1efaafd3f408679.svg";